import { Footer } from "components/Footer";
import { HeaderBar } from "components/HeaderBar";
import AutoLoginProvider from "features/AutoLogin/AutoLoginProvider";
import ModalProvider from "features/Modal/ModalProvider";
import { NavigationDrawer } from "features/NavigationDrawer/NavigationDrawer";
import ThemeProvider from "features/Theme/ThemeProvider";
import { About } from "pages/About";
import { Main } from "pages/Main";
import { PrivacyPolicy } from "pages/PrivacyPolicy";
import { Product } from "pages/Product";
import SignUp from "pages/SignUp";
import React, { useEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import styled from "styled-components/macro";
import { GlobalFonts } from "styles/GlobalFonts";
import SignIn from "./pages/SignIn";
import GlobalStyle from "./styles/GlobalStyle";

const Wrapper = styled.div`
  margin: 0 auto;
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.text};
  padding: 0;
`;

function App() {
  const location = useLocation();

  useEffect(() => {
    setTimeout(() => {
      if (location.hash) {
        const targetElement = document.querySelector(location.hash);
        if (targetElement) {
          targetElement.scrollIntoView();
        }
      } else {
        window.scrollTo(0, 0);
      }
    }, 100);
  }, [location.pathname, location.hash]);

  return (
    <ThemeProvider>
      <AutoLoginProvider>
        <GlobalStyle />
        <GlobalFonts />
        <Wrapper>
          <HeaderBar />
          <Switch>
            <Route path="/signin" component={SignIn} />
            <Route path="/signup" component={SignUp} />
            <Route path="/privacy" component={PrivacyPolicy} />
            <Route path="/about" component={About} />
            <Route path="/product" component={Product} />
            <Route path="/" component={Main} />
          </Switch>
          <Footer />
          <NavigationDrawer />
          <ModalProvider />
        </Wrapper>
      </AutoLoginProvider>
    </ThemeProvider>
  );
}

export default App;
